/**
 *  Alaska
 *  Public: Header
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('headerState', () => ({
        mobile_menu_open: false,
        scrolled: false,
        revealAfterHero: false,
        heroPassed: false,
        headerHeight: 0,
        heroObserver: null,
        headerResizeObserver: null,

        init() {
            this.$nextTick(() => {
                this.observe_header_height();
                this.observe_hero();
            });
        },

        observe_header_height() {
            const headerBar = this.$refs.headerBar;
            if (!headerBar) return;

            const update = () => {
                const height = Math.round(headerBar.getBoundingClientRect().height);

                if (height === this.headerHeight) return;
                
                this.headerHeight = height;

                document.documentElement.style.setProperty(
                    '--menu-height', 
                    this.headerHeight + 'px'
                );
            };

            update();

            this.headerResizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(update);
            });

            this.headerResizeObserver.observe(headerBar);
        },

        observe_hero() {
            const hero = document.querySelector('.js-nav-after-hero');
            this.revealAfterHero = Boolean(hero);

            if (!hero) return;

            this.heroObserver = new IntersectionObserver(
                ([entry]) => { this.heroPassed = !entry.isIntersecting; },
                { threshold: 0 }
            );
            this.heroObserver.observe(hero);
        },

        handle_scroll() {
            this.scrolled = window.scrollY > 20;
        },

        toggle_mobile_menu() {
            this.mobile_menu_open = !this.mobile_menu_open;
        },

        destroy() {
            this.heroObserver?.disconnect();
            this.headerResizeObserver?.disconnect();
        },
    }));
});